  
export interface ModularSurveyResponse {
  id:             number;
  name:           SurveyNameRecordLang;
  structure:      StructureRecordLang;
  style:          Style;
  main_language:  null;
  greeting:       GreetingRecordLang;
  created_at:     string;
  updated_at:     string;
  client_id:      number;
  distributor_id: null;
  owner:          string;
  ticket:         number;
}

export type SurveyNameRecordLang = Record<string, string>;
export type GreetingRecordLang = Record<string, string>;
export type StructureRecordLang = Record<string, StructureField[]>;

export interface StructureField {
  type:     FieldType;
  required: boolean;
  title?:   string;
  description?: string;
  options?: string[];
  values?: string[];
}

export type FieldType = typeof fieldTypeRaw[keyof typeof fieldTypeRaw];
export const fieldTypeRaw = {
  satisfaction_level_3: 'satisfaction_level_3',
  satisfaction_level_5: 'satisfaction_level_5',
  textarea:             'textarea',
  text:                 'text',
  selection_multi:      'selection_multi',
  selection_unique:     'selection_unique',
  email:                'email'
} as const;

export interface Style {
  header_color: string;
  bg_color:     string;
  survey_color: string;
  text_color:   string;
  logo?: Logo;
}
 
export interface Logo {
  original_name: string; // it is not used
  url: string;
}